const state = () => ({
    active: false,
    timeout: 300,
    idleTimeout: 0,
    isPrompted: false,
});

const actions = {};

const getters = {};

const mutations = {
    /**
     * 閒置時間
     * @param {*} state
     * @param {*} payload
     */
    setIdleTimeout(state, payload) {
        state.idleTimeout = payload;
    },
    /**
     * 用在 debug panel 上的倒數時間
     * @param {*} state
     * @param {*} payload
     */
    setTimeout(state, payload) {
        state.timeout = payload;
    },
    /**
     * 顯示閒置提醒彈跳視窗
     * @param {*} state
     * @param {*} payload
     */
    showPrompt(state, payload) {
        state.timeout = payload.timeout;
        state.isPrompted = true;
    },
    /**
     * 隱藏閒置提醒彈跳視窗
     */
    hidePrompt(state) {
        state.idleTime = 0;
        state.isPrompted = false;
    },
    /**
     * 清除倒數時間
     * @param {*} state
     */
    clearAllTimeout(state) {
        state.idleTimeout = 0;
        state.timeout = 0;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
